<script>
  import logo from "../img/logo.svg";
</script>

<div class="row mb-3 mt-3 mt-md-0 justify-content-center">
  <div class="col-12 col-md-auto">
    <div class="p-3 text-center border-primary">
      <h6 class="">Radio Quartiere fa parte dalla comunità di</h6>
      <a href="https://openpod.abbiamoundominio.org" target="_blank">
        <img width="160px" height="auto" src={logo} alt="openpod logo" />
      </a>
    </div>
  </div>
</div>
